import { lazy } from 'react';
import CameraCapture from '../view/fid/CameraCapture';

/** UCF ROUTES IMPORT STARTS HERE */
const Login = lazy(() => import("./../view/login/Login"));
const RemoveInfo = lazy(() => import("./../view/login/RemoveInfo.js"));
const RefinanceLoanSoftApprovalProcess = lazy(() => import("../view/refinance/loan-soft-approval/LoanSoftApprovalProcess.js"));
const RefinanceLoanSoftApprovalProcessBM = lazy(() => import("../view/refinance/loan-soft-approval/LoanSoftApprovalProcessBM.js"));
// financer box 
const LoanApprovalProcess = lazy(() => import("../view/loan-approval/LoanApprovalProcess"));
const LoanApprovalProcessBM = lazy(() => import("../view/loan-approval/LoanApprovalProcessBM"));
const Thanks = lazy(() => import("../view/common/Thanks"));
const BPKPUpdate = lazy(() => import("../view/inventory-funding/bpkp/BPKPUpdate"));
const BPKList = lazy(() => import("../view/inventory-funding/bpkp/BPKList"));
const Logout = lazy(() => import("../view/login/logout.js"));
const Dashboard = lazy(() => import("../view/dashboard/Dashboard"));
const LokataraLogin = lazy(() => import("./../view/lokatara-login/Login.js"));
const routes = [
  { path: '/', Component: Login, exact: true },
  { path: '/login', Component: Login, exact: false },
  { path: '/logout', Component: Logout, exact: false },
  { path: '/remove-info', Component: RemoveInfo, exact: false },
  { path: '/dashboard', Component: Dashboard, exact: false },
  { path: '/refinance/loan-soft-approval-process/:url_token/:lead_id_hash/:lead_application_id_hash/:type', Component: RefinanceLoanSoftApprovalProcess, exact: false },
  { path: '/refinance/bm-loan-soft-approval-process/:url_token/:lead_id_hash/:lead_application_id_hash/:type', Component: RefinanceLoanSoftApprovalProcessBM, exact: false },
  { path: '/loan-approval-process/:token/:lead_id/:type', Component: LoanApprovalProcess, exact: false },
  { path: '/bm-loan-approval-process/:token/:lead_id/:type', Component: LoanApprovalProcessBM, exact: false },
  { path: '/bpkp-update/:token/:lead_id', Component: BPKPUpdate, exact: false },
  { path: '/bpkp-update/:token', Component: BPKPUpdate, exact: false },
  { path: '/bpkp-list/:token', Component: BPKList, exact: false },
  { path: '/thanks', Component: Thanks, exact: false },
  { path: '/fid-loan-approval-process/:token/:lead_id/:financier_id', Component: CameraCapture, exact: false },
  { path: '/lokatara', Component: LokataraLogin, exact: false },
];
export default routes;

